import { booleanPointInPolygon, point as createPoint, polygon as createPolygon } from "@turf/turf";
import type { XY } from "@designboticteam/core";
import { toClosedPolygon } from "@designboticteam/kolega-3d";

/**
 * Returns true when a point lies inside or on the boundary of a polygon projected onto the x/z plane.
 */
function isPointInsidePolygon(point: XY, polygon: Array<XY>): boolean {
	const ring = toClosedPolygon(polygon);

	if (ring === null) {
		return false;
	}

	return booleanPointInPolygon(createPoint(point), createPolygon([ring]));
}

export { isPointInsidePolygon };
